import { ApiData } from '../../../models'
import { WhitelabelSettings } from './WhitelabelSettings';

export class WhitelabelState {
    settings: ApiData<WhitelabelSettings>;
    constructor () {
        this.settings = new ApiData<WhitelabelSettings>()
    }
}